import { DeleteRounded } from "@mui/icons-material"
import { Chip, IconButton } from "@mui/material"
import dayjs from "dayjs"
import { numberFormat } from "utils"

export const driverAdvancePayV2Columns = (handleDelete) => [
  {
    field: "PayTm", headerName: "วันที่เบิก", width: 110,
    valueFormatter: ({ value }) => value ? dayjs(value).format("DD/MM/YYYY") : "-",
  },
  { field: "DrvCd", headerName: "รหัส", width: 70 },
  { field: "DrvNm", headerName: "พนักงานขับรถ", width: 180 },
  {
    field: "Amnt", headerName: "จำนวนเงิน", width: 110, align: "right", type: "number",
    valueFormatter: ({ value }) => value == null ? "-" : numberFormat(value),
  },
  { field: "Dscp", headerName: "หมายเหตุ", flex: 1, minWidth: 150 },
  {
    field: "settle", headerName: "สถานะหักเงินเดือน", width: 180, sortable: false,
    renderCell: ({ row }) => row.PayrollId
      ? <Chip size="small" color="success" label={`หักงวด ${row.SettleSalDte ? dayjs(row.SettleSalDte).format("MM/YYYY") : ""}`} />
      : <Chip size="small" variant="outlined" label="ยังไม่หัก" />,
  },
  {
    field: "actions", headerName: "", width: 60, align: "center", sortable: false,
    renderCell: ({ row }) => !row.PayrollId && (
      <IconButton size="small" sx={{ p: 0 }} onClick={() => handleDelete(row)}>
        <DeleteRounded color="error" />
      </IconButton>
    ),
  },
]
